import React from 'react';
import Select from 'react-select';
import 'whatwg-fetch';
import { filterSelect } from '../../utils/utils';

import ringAnim from '../../images/anim/ring.svg';

const apiBarCode = '/__api__/api/stock/barcode/';

const oriState = {
  stepView: 1,
  productSelected: null,
  refId: -1,
  stockId: -1,
  productQuantity: 1,
  agency: {
    // object that contains an id
    id: 1,
  },
};

export default class AppStockModalAdd extends React.Component {
  constructor(props) {
    super(props);
    this.state = oriState;

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputSelectChange = this.handleInputSelectChange.bind(this);
    this.reset = this.reset.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
    this.openLabelPlank = this.openLabelPlank.bind(this);
  }

  reset() {
    this.state = oriState;
    this.setState(oriState);
    this.componentDidMount();
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  handleInputSelectChange(val) {
    const value = val ? val['id'] : undefined;

    this.setState({
      refId: value,
    });
  }

  componentDidMount() {}

  openLabelPlank() {
    let url = apiBarCode;

    let form = document.createElement('form');
    form.method = 'POST';
    form.action = url;
    form.target = '_blank';

    let input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'stockEntry';
    input.value = JSON.stringify(this.props.urlBarCode);
    form.appendChild(input);
    document.body.appendChild(form);
    form.submit();
  }

  render() {
    if (this.props.isOpen === false) return null;

    const dataRef = this.props.dataHardware;
    const dataStock = this.props.dataStock;

    return (
      <div className='modal myModal'>
        <div className='modal-dialog modal-md'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h4 className='modal-title'>Ajouter Produit(s)</h4>
              <button onClick={this.close} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                <span aria-hidden='true'>&times;</span>
              </button>
            </div>
            <form>
              {this.state.stepView === 1 && (
                <div className='modal-body'>
                  <div className='form-group'>
                    <label htmlFor='exampleSelect1'>Référence</label>
                    <Select
                      className='inputModalSelect'
                      name='refId'
                      value={this.state.refId}
                      labelKey={'wording'}
                      valueKey={'id'}
                      options={dataRef}
                      onChange={this.handleInputSelectChange}
                      noResultsText={'Aucun résultat'}
                      placeholder={'Choisir...'}
                      clearValueText={'Supprimer'}
                      ignoreCase={false}
                      filterOption={filterSelect}
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='inputCost'>Quantité</label>
                    <input
                      min={1}
                      max={50}
                      name='productQuantity'
                      value={this.state.productQuantity}
                      onChange={this.handleInputChange}
                      type='number'
                      className='form-control inputPrice'
                      id='inputCost'
                      placeholder='...'
                    />
                  </div>
                  <div className='form-group'>
                    <label htmlFor='exampleSelect1'>Stock</label>
                    <select
                      name='stockId'
                      value={this.state.stockId}
                      onChange={this.handleInputChange}
                      className='form-control'
                      id='exampleSelect1'
                    >
                      <option key={-1} value={-1}>
                        Choisir stock
                      </option>
                      {dataStock ? (
                        dataStock.map((data, i) => (
                          <option key={data.id} value={data.id}>
                            {data.name}
                          </option>
                        ))
                      ) : (
                        <span>Chargement...</span>
                      )}
                    </select>
                  </div>
                </div>
              )}
              {this.state.stepView === 2 && (
                <div className='modal-body'>
                  <p>
                    1) Appuyez sur <b>+Code-Barre</b> pour ouvrir la planche de codes-barres.
                    <br />
                    <br />
                    {this.props.urlBarCode ? (
                      <button onClick={this.openLabelPlank} type='button' className='btn btn-sm btn-outline-success'>
                        <span className='icon icon-plus'>Code-Barre</span>
                      </button>
                    ) : (
                      <div className='alignHorizontal'>
                        <img src={ringAnim} />
                      </div>
                    )}
                    <br />
                    <br />
                    2) Imprimez le document .pdf avec une imprimante disposant de papier étiquette.
                    <br />
                    3) Collez les étiquettes sur les produits.
                    <br />
                    4) Appuyez sur <b>Valider</b> pour enregistrer les produits.
                    <br />
                    5) Félicitation, les produits sont maintenant disponibles dans le stock.
                    <br />
                    <br />
                    <div className='alert alert-warning' role='alert'>
                      <strong>En cas d'erreur lors de l'impression => </strong>
                      Pas de panique, Appuyez sur <b>Annuler</b> pour supprimer les produits. Merci de recommencer
                      ensuite la procédure. <br />
                      En cas d'erreur réseau, un fichier sera téléchargé avec la liste des codes-barre à supprimer. Il
                      suffit ensuite de copier-coller les codes-barre séparés par des virgules dans +Actions ->
                      Supprimer.
                    </div>
                  </p>
                </div>
              )}
              <div className='modal-actions'>
                <button onClick={this.close} type='button' className='btn-link modal-action' data-dismiss='modal'>
                  Annuler
                </button>
                <button
                  onClick={this.handleSubmit}
                  type='button'
                  className='btn-link modal-action'
                  data-dismiss='modal'
                >
                  <strong>{this.state.stepView === 1 ? 'Suivant' : 'Valider'}</strong>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  close() {
    this.reset();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleSubmit() {
    if (this.state.stepView === 1) {
      // We go on the second step
      if (this.state.stockId !== -1 && this.state.refId !== -1) {
        let json = {
          stock: {
            id: this.state.stockId,
          },
          quantity: this.state.productQuantity,
          product: {
            reference: {
              id: this.state.refId,
            },
          },
        };
        this.props.onPost(json);

        this.setState({
          stepView: 2,
        });
      } else {
        this.props.openToast(false, 'Veuillez remplir le formulaire.');
      }
    } else {
      // We send the request in order to register the products
      this.props.onFinish();
      this.close();
    }
  }
}
